export default {
  "brand.name": "AllChinaBuy Spreadsheet",
  "brand.tagline": "Recherche de produits & QC",

  "nav.home": "Accueil",
  "nav.shoppingGuide": "Guide d'achat",
  "nav.categories": "Catégories",
  "nav.qc": "Photos QC",
  "nav.shipping": "Livraison",
  "nav.review": "Avis",
  "nav.safety": "Sécurité",
  "nav.buyNow": "Acheter maintenant",

  "lang.en": "English",
  "lang.fr": "Français",
  "lang.da": "Dansk",
  "lang.de": "Deutsch",

  "hero.badge": "Ressource indépendante · Mise à jour 2026",
  "hero.title": "AllChinaBuy Spreadsheet — Trouvez des produits, des photos QC et de meilleurs guides d'achat",
  "hero.subtitle": "Explorez les feuilles de calcul AllChinaBuy, les trouvailles produits, les informations QC, les guides de livraison, les astuces d'entrepôt, les coupons et les ressources de sécurité au même endroit.",
  "hero.ctaExplore": "AllChinaBuy Spreadsheet",
  "hero.ctaBuyNow": "Acheter maintenant",
  "hero.searchPlaceholder": "Rechercher des feuilles AllChinaBuy, produits, QC ou livraison...",
  "hero.dropdownLabel": "Parcourir les catégories de produits",
  "hero.noResults": "Aucune catégorie trouvée",

  "categories.title": "Catégories de produits populaires",
  "categories.subtitle": "Accédez directement à n'importe quelle catégorie de produits sur le site principal AllChinaBuy Spreadsheet.",
  "categories.shoes": "Chaussures",
  "categories.hoodies": "Hoodies / Sweats",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Vestes",
  "categories.pants": "Pantalons / Shorts",
  "categories.headwear": "Couvre-chefs",
  "categories.sets": "Ensembles",
  "categories.underwear": "Sous-vêtements / Caleçons",
  "categories.jersey": "Maillots",
  "categories.accessories": "Accessoires",
  "categories.bags": "Sacs",
  "categories.belts": "Ceintures",
  "categories.perfumes": "Parfums",
  "categories.other": "Autres articles",

  "what.title": "Qu'est-ce qu'un AllChinaBuy Spreadsheet ?",
  "what.body": "Un AllChinaBuy Spreadsheet est une feuille partagée et organisée qui rassemble les liens produits, prix, tailles, photos QC et notes de livraison des articles que vous souhaitez acheter via AllChinaBuy. Au lieu de jongler avec des dizaines d'onglets, vous gardez tout au même endroit — ce qui simplifie la recherche, la commande et le contrôle qualité.",

  "qc.title": "Photos QC & guide qualité",
  "qc.body": "Les photos de contrôle qualité vous permettent d'inspecter un article avant son expédition. Une bonne feuille suit les liens des photos QC, les mesures et les éventuels défauts, afin de confirmer que le produit correspond à l'annonce avant de payer la livraison internationale.",

  "shipping.title": "Guide des frais de livraison AllChinaBuy",
  "shipping.body": "Les frais de livraison dépendent du poids, du volume et de la ligne choisie. Une feuille bien structurée enregistre le poids estimé, les options de ligne et le coût final de chaque colis, ce qui vous aide à planifier un budget et à choisir l'itinéraire le plus économique vers votre pays.",

  "review.title": "Avis AllChinaBuy & confiance",
  "review.body": "Nous résumons les expériences réelles, les avantages et inconvénients, les délais de livraison et la qualité du support. Vérifiez toujours les conditions et politiques en vigueur sur la plateforme officielle AllChinaBuy avant de décider.",

  "safety.title": "Centre de sécurité",
  "safety.body": "Évitez les fausses feuilles et les liens suspects. N'utilisez que des sources fiables, vérifiez les vendeurs, comprenez les règles douanières et fiscales, et ne partagez jamais vos informations de paiement en dehors des canaux officiels.",

  "articles.title": "Derniers guides & articles",
  "articles.subtitle": "Des guides SEO originaux et approfondis autour du thème AllChinaBuy Spreadsheet.",
  "articles.card.title": "AllChinaBuy Spreadsheet : le guide complet 2026",
  "articles.card.excerpt": "Découvrez ce qu'est un AllChinaBuy Spreadsheet, comment l'utiliser pour la recherche et le QC, le vrai coût de la livraison, et si AllChinaBuy est sûr et fiable.",
  "articles.card.readMore": "Lire le guide",
  "articles.card.meta": "Guide · 8 min de lecture",

  "faq.title": "Questions fréquentes",
  "faq.q1": "AllChinaBuy est-il légitime ?",
  "faq.a1": "AllChinaBuy est un agent d'achat bien connu. Utilisez toujours le site officiel et vérifiez les politiques avant de commander. Ce site indépendant n'est pas la plateforme officielle.",
  "faq.q2": "Combien coûte la livraison AllChinaBuy ?",
  "faq.a2": "Le coût dépend du poids, du volume et de la ligne choisie. Les colis plus légers et plus petits ainsi que les lignes économiques coûtent généralement moins cher.",
  "faq.q3": "Qu'est-ce qu'un AllChinaBuy Spreadsheet ?",
  "faq.a3": "C'est une feuille partagée qui organise les liens produits, prix, photos QC et notes de livraison des articles de votre colis.",
  "faq.q4": "AllChinaBuy propose-t-il des photos QC ?",
  "faq.a4": "Oui, des photos QC sont disponibles pour de nombreuses commandes afin d'inspecter les articles avant leur expédition internationale.",
  "faq.q5": "Comment trouver des coupons ou codes promo AllChinaBuy ?",
  "faq.a5": "Consultez le site officiel et les communautés fiables pour les offres en cours. Nous ne publions pas de coupons ou promotions non vérifiés.",

  "final.title": "Prêt à explorer le AllChinaBuy Spreadsheet ?",
  "final.subtitle": "Ouvrez la feuille complète pour parcourir les produits, vérifier les photos QC et planifier votre prochain colis.",
  "final.button": "Ouvrir le AllChinaBuy Spreadsheet",

  "footer.disclaimer": "AllChinaBuySpread.uk est une ressource d'information indépendante et n'est pas le site officiel AllChinaBuy. Les informations peuvent changer. Vérifiez les prix, promotions, règles et politiques de livraison en vigueur avant de prendre une décision.",
  "footer.rights": "Tous droits réservés.",
  "footer.guide": "Guide Spreadsheet",
  "footer.home": "Accueil",
}